import React from "react";
import { useTranslation } from "react-i18next";
import { Mail, Globe, HelpCircle, FileDown } from "lucide-react";

const SUPPORT_EMAIL = "contact@squareandcompass.store";
const SUPPORT_WEBSITE = "https://www.squareandcompass.store";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function SupportPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="support-page">
      <h1 className="page-title">{t("support.title")}</h1>
      <p className="page-subtitle">{t("support.subtitle")}</p>

      <div className="gold-divider my-8" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="panel">
          <div className="panel-head">{t("support.contact")}</div>
          <div className="panel-body space-y-3">
            <div className="flex items-center gap-3" data-testid="support-website">
              <Globe size={16} color="#c9a84c" />
              <a href={SUPPORT_WEBSITE} target="_blank" rel="noreferrer" style={{ color: "#0d1b2a" }}>
                www.squareandcompass.store
              </a>
            </div>
            <div className="flex items-center gap-3" data-testid="support-email">
              <Mail size={16} color="#c9a84c" />
              <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: "#0d1b2a" }}>{SUPPORT_EMAIL}</a>
            </div>
            <p style={{ marginTop: "0.8rem", color: "#34322d" }}>
              {t("support.contactBody")}
            </p>
            <div className="pt-3" style={{ borderTop: "1px solid #e8e3d4" }}>
              <a
                href={`${API}/api/docs/user-manual.pdf`}
                target="_blank"
                rel="noreferrer"
                className="btn-lodge-gold inline-flex items-center gap-2"
                data-testid="support-user-manual-link"
              >
                <FileDown size={16} />
                {t("support.downloadManual")}
              </a>
              <p style={{ marginTop: "0.6rem", color: "#858481", fontStyle: "italic", fontSize: "0.85rem" }}>
                {t("support.manualHint")}
              </p>
            </div>
          </div>
        </div>

        <div className="panel">
          <div className="panel-head">{t("support.overview")}</div>
          <div className="panel-body">
            <div className="flex items-start gap-3">
              <HelpCircle size={20} color="#c9a84c" className="shrink-0 mt-1" />
              <div>
                <p>{t("support.appOverview")}</p>
                <p className="mt-3" style={{ color: "#858481", fontStyle: "italic" }}>
                  {t("support.glory")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
